import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  Input,
  ViewChild,
} from '@angular/core';

import { ChatMessageRole, Message } from '../../services/chat.models';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-chat-input',
  templateUrl: './chat-input.component.html',
  styleUrls: ['./chat-input.component.css'],
})
export class ChatInputComponent {
  @Input() deactivated: boolean = false;
  @Output() openViewer = new EventEmitter<string>();
  // @Output() newMessage = new EventEmitter<any>();
  @Output() updateChatConfig = new EventEmitter<any>();
  @ViewChild('textarea') textArea!: ElementRef;

  message: string;
  showChatConfig: boolean = false;
  showExtraProduct: boolean = false;

  constructor(private chatService: ChatService) {
    // this.chatService.currentChat.subscribe((chat) => {
    //   this.currentChat = chat;
    //
    //   this.model = chat.model;

    //   // update the drop down with the current model
    // });
    this.message = '';
    // if product id is not fr, de, or es then show extra product
  }

  ngOnChanges() {}

  // async fetchProducts() {
  //   this.products = await this.productService.listProducts();
  // }

  toggleChatConfig() {
    this.showChatConfig = !this.showChatConfig;
  }

  sendMessage() {
    if (this.deactivated) return;
    if (!this.message.trim()) return;
    if (!this.chatService?.currentChat?.id) {
      this.chatService.addChat('New Chat', this.message.trim(), true);
    } else {
      const newMessages: Message[] = [];
      if (this.message.length > 0) {
        const userPromptMessage: Message = new Message({
          from: ChatMessageRole.User,
          text: this.message,
          type: 'text',
          isHidden: false,
          partToShow: '',
        });
        newMessages.push(userPromptMessage);
      }

      let msg_info: { id: string; message: Message[] } = {
        id: this.chatService.currentChat.id,
        message: newMessages,
      };
      this.updateMessages(msg_info);
    }
    this.message = '';
    setTimeout(() => this.adjustTextarea(null), 0); // Adjust textarea after message is sent
  }

  updateMessages(msgInfo: { id: string; message: Message[] }) {
    this.chatService.sendMessage(msgInfo.id, msgInfo.message);
  }

  adjustTextarea(event: any) {
    setTimeout(() => {
      const textarea: any = event
        ? event.target
        : document.querySelector('textarea');
      if (textarea.value === '') {
        // Reset textarea size if there's no content
        textarea.style.height = 'auto';
      } else if (textarea.scrollHeight < 300) {
        // Increase height if scrollHeight is under 150.
        textarea.style.height = `${textarea.scrollHeight}px`;
      } else if (textarea.clientHeight < 300) {
        // If content is larger but textarea's visible height is less, set it to 150
        textarea.style.height = `300px`;
      }
    }, 0);
  }
}
